import React, {useEffect, useState} from "react";
import {Card, CardBody, CardTitle} from "reactstrap";
import {connect, useSelector} from "react-redux";

// components
import AfiPickupScheduleList from "./_list";
import SelectSchedule from "../../../components/schedules/SelectSchedule";
import {GenericTableButton} from "../../../components/buttons/buttonsActions";

// labels
import {TT_ADD} from "../../../components/i18n/toolTips";

// actions
import {clearState} from "../../../redux/actions/generalActions/subFormActions";
import {getStateByPath} from "../../../redux/selectors";

const AfiPickupSchedule = props => {
    const componentState = useSelector(state => getStateByPath(state, props.path));
    const { domainObject:afi, udn:udnHotel } = componentState?.data;

    const [showSelectSchedule, setShowSelectSchedule] = useState(false)

    // limpieza del estado cuando se desmonta el componente
    useEffect(() => {
        return () => {
            props.clearState()
        }
    },[])

    const changeShowSelectSchedule = value => setShowSelectSchedule(value)

    return <Card>
        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="fas fa-clock mr-2"/> Salidas del { udnHotel?.code } hacia { afi?.name }
            <div className="float-right">
                <GenericTableButton
                    toolTip={TT_ADD}
                    clazz={'btn-card-title'}
                    icon={ !showSelectSchedule ? 'fa-plus' : 'fa-close'}
                    permission={'edit'}
                    onClick={()=> setShowSelectSchedule(!showSelectSchedule)}
                />
            </div>
        </CardTitle>
        <CardBody >
            {
                !showSelectSchedule
                    ? <AfiPickupScheduleList path={props?.path} />
                    : <SelectSchedule path={props?.path} onClose={changeShowSelectSchedule}/>
            }
        </CardBody>
    </Card>
};

const mapStateToProps = state => ({});
const mapActionsToProps = ({ clearState, });

export default connect(mapStateToProps, mapActionsToProps)(AfiPickupSchedule);